import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/styles/index.css";
import App from "./app/App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Account } from "./contexts/Account";
//import { AuthProvider } from "./contexts/AuthContext";
import { UserData } from "./contexts/UserDataContext";
import { Lists } from "./features/lists";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  
  <React.StrictMode>
    <meta name="viewport" content="width=device-width" initial-scale="1.00" maximum-scale="1.0" />
    <BrowserRouter>
      <Account>
        <UserData>
          <Lists>
            <App />
          </Lists>
        </UserData>
      </Account>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
